module.exports = __webpack_public_path__ + "static/media/worker_black.c61d4942.svg";